/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useState } from 'react';
import _ from 'lodash';
import calculateSize from 'calculate-size';
import { makeStyles } from '@material-ui/core/styles';
import { Tooltip } from '@material-ui/core';

import ProblemsDialog from './ProblemsDialog';
import { timeRangeFormatter } from '../../utilities';
import { useFetchProblems } from '../problems/FetchProblems';
import { useFilterControl } from '../page-framework/filter/FilterControl';
import { getLogger } from '../../utilities/UseLog';

const log = getLogger('Problems');

const useStyles = makeStyles((theme) => ({
    flex: {
        display: 'flex',
    },
    expand: {
        flex: 1,
    },
    visible: {
        position: 'relative',
        visibility: 'visible',
        fontSize: '14px',
        textAlign: 'left',
        fontWeight: 'bold',
        color: theme.palette.type === 'light' ? 'rgb(58, 97, 120)' : 'rgb(69, 151, 203)',
        background: 'none',
        margin: '10px 0px',
        padding: 0,
        border: 'none',
        cursor: 'pointer',
        outline: 'none',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    hidden: {
        visibility: 'hidden',
        fontSize: '14px',
        textAlign: 'left',
        fontWeight: 'bold',
        margin: 0,
        padding: 0,
        border: 'none',
        cursor: 'pointer',
        outline: 'none',
    },
}));

const estimateProblemsPosition = (positions, problemsStr) => {
    const estimateSize = calculateSize(problemsStr, {
        font: 'Roboto',
        fontSize: '14px',
    }).width;
    const centerSlot = positions.position + positions.pointWidth / 2;
    const estPos = centerSlot - estimateSize / 2; // position center of time slot
    const fPos = Math.min(estPos, positions.chartWidth - estimateSize); // do not overflow chart
    const pos = Math.max(0, fPos); // do not underflow chart
    return _.isNaN(pos) ? 0 : pos;
};

export default function Problems({ positions, timeRange, entityType, entityUuid }) {
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const filterControl = useFilterControl();

    if (!entityUuid) log.warn(`Trying to query problems for undefined entityUuid of type ${entityType}`);

    const problemsResult = useFetchProblems(
        timeRange,
        entityType,
        entityUuid || '00000000-0000-0000-0000-000000000000'
    );

    if (!problemsResult) return <div className={classes.hidden}> </div>;

    if (problemsResult.error) return <div className={classes.visible}>{`ERROR: ${problemsResult.error}`}</div>;

    const problems = problemsResult.result;
    const total = problems?.total;
    const problemStr = `${total} ${total > 1 ? 'Problems' : 'Problem'}`;

    if (!total) return <div className={classes.hidden}>{problemStr}</div>;

    const positionStyle = {
        left: estimateProblemsPosition(positions, problemStr),
    };

    function handleDialogOpen() {
        filterControl.pauseAutoRefresh();
        setOpen(true);
    }

    function handleDialogClose() {
        filterControl.resumeAutoRefresh();
        setOpen(false);
    }

    return (
        <div className={classes.flex}>
            <Tooltip title={`View alerts ${timeRangeFormatter(timeRange)}`} placement="top">
                <div className={classes.visible} style={positionStyle} onClick={handleDialogOpen}>
                    {problemStr}
                </div>
            </Tooltip>
            <div className={classes.expand} />
            <ProblemsDialog
                open={open}
                onClose={handleDialogClose}
                total={total}
                timeRange={timeRange}
                entityType={entityType}
                entityUuid={entityUuid}
            />
        </div>
    );
}
